// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__H2HDD","rotate":"Spinner_rotate__eIvct","path":"Spinner_path__t0smQ","dash":"Spinner_dash__FMWAN"};